import { Directive } from '@angular/core';

/**
 * Marker directive used to detect whether a `[batteryPausedInfo]` block is
 * projected into `web-device-data`.
 */
@Directive({
    selector: '[webBatteryPausedInfo]',
})
export class BatteryPausedInfoDirective {}
